export default "__VITE_ASSET__55a8e6ea__"